import { uploadSingleFile } from "../files";
import { API, authClient } from "../index";

export const postActivity = async (activity) => {
	return authClient().post(`${API}/activity`, activity);
};

export const getActivities = () => {
	return authClient().get(`${API}/activity?getDisabled=true`);
};

export const getActivityById = (id) => {
	return authClient().get(`${API}/activity/${id}`);
};

export const updateActivity = async (id, activity, image) => {
	return authClient().put(`${API}/activity/${id}`, activity);
};

export const changeStatusActivity = async (id, active) => {
	return authClient().put(`${API}/activity/change-status/${id}`, {
		active,
	});
};

export const deleteActivity = (id) => {
	return authClient().delete(`${API}/activity/${id}`);
};
